import styled from 'styled-components'

export const EmbeddedWrapper = styled.div`
  margin-bottom: 1rem;
`
